module.exports = __webpack_public_path__ + "img/achievements.1604df8d.svg";